// extracted by mini-css-extract-plugin
export default {"mainCard":"MainCard_mainCard__P9eTq","mapRow":"MainCard_mapRow__CEYcg"};